export enum CreditType {
    PartialCredit = "PartialCredit",
    FullCredit = "FullCredit",
}
